/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Rechts-naar-links",
		"timeZoneID": "Tijdzone",
		"skin": "Stijl",
		"metricsFileImportTask": "Nieuwe import vanuit Bestanden",
		"displayMode": "Standaardview",
		"credentialRenewed": "Uw legitimatiegegevens zijn vernieuwd met uw huidige gebruikers-ID en wachtwoord.",
		"productLocale": "Producttaal",
		"toggleDisabled": "uit",
		"credentialChange": "Vernieuwen",
		"log_level_Debug": "Foutopsporing",
		"confirmNewPassword": "Nieuw wachtwoord bevestigen",
		"unsavedViewMsg2": "Als u uw wijzigingen niet eerst opslaat, gaan ze verloren.",
		"supportPortalErrorMessage": "Probeer het opnieuw.  Als het probleem blijft bestaan, waarschuwt u de beheerder.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation en anderen 2005, %{year}. IBM, het IBM-logo, ibm.com en Cognos zijn merken van International Business Machines Corp., wereldwijd geregistreerd in tal van rechtsgebieden. Een actuele lijst van merken van IBM is beschikbaar op internet beschikbaar, op www.ibm.com/legal/copytrade.shtml. Dit Programma wordt in licentie gegeven onder de voorwaarden van de licentieovereenkomst waarvan het Programma vergezeld gaat. Deze licentieovereenkomst kan zich in een map van het Programma met de naam \"License\" of \"Non_IBM_License\" bevinden, indien van toepassing, of als gedrukte licentieovereenkomst zijn verstrekt. Lees de overeenkomst zorgvuldig door voordat u het Programma gebruikt. Door het Programma te gebruiken, gaat u akkoord met deze voorwaarden.",
		"groupsAndRoles": "Groepen en rollen",
		"metricsMaintenanceTask": "Nieuw onderhoud",
		"email": "E-mail",
		"contextual": "Contextueel",
		"resetHome": "Standaardwaarden opnieuw instellen",
		"ltr": "Links-naar-rechts",
		"credentials": "Legitimatiegegevens",
		"logging_congfig_title": "Logboekregistratie",
		"changePasswordTitle": "Mijn wachtwoord wijzigen",
		"format": "Rapportindeling",
		"showUnread": "Ongelezen items afbeelden",
		"AILearning_active": "AI-learning over:",
		"docsErrorMessage": "Probeer het opnieuw.  Als het probleem blijft bestaan, waarschuwt u de beheerder.",
		"toggleEnabled": "aan",
		"homeSetError": "Er is een fout opgetreden tijdens het instellen van de standaardhomepage; probeer deze view te sluiten en opnieuw te openen.",
		"passwordChange": "Uw wachtwoord wijzigen",
		"profile": "Profiel",
		"pdfRestricted": "PDF (Beperkt)",
		"drillThrough": "Definities voor doordrillen",
		"homeSet": "Uw homepage is ingesteld",
		"regionalOptions": "Landopties",
		"myPreferences": "Mijn voorkeuren",
		"defaultHome": "Standaardwaarde",
		"version": "Versie",
		"controller": "Controller",
		"manage": "Beheren",
		"biDirectionalFeaturesEnabled": "Ondersteuning van bidirectionele talen",
		"newFeaturesErrorTitle": "De link naar Nieuwe functies werkt niet.",
		"passwordMatch": "Wachtwoord komt overeen",
		"updateProfileAndsettings": "Profiel en instellingen bijwerken",
		"dashboardConsole": "Werkgebied",
		"legacyAppsSlideoutLabel": "Beschikbare legacytoepassingen",
		"logging_config_description": "Logboekregistratie wordt gebruikt bij het oplossen van problemen. Neem contact op met de beheerder voor informatie over instellingen.",
		"confirmDeletion": "Wissen bevestigen",
		"signInButtonText": "Aanmelden",
		"dataSourceCredentials": "Legitimatiegegevens gegevensserver",
		"AILearningConfigurationSlideoutAllyLabel": "Configuratie AI-learning",
		"loadingSettings": "Instellingen laden",
		"spreadsheetMLRestricted": "Excel (Beperkt)",
		"manageAILearning": "AI-learning",
		"xlsxDataRestricted": "Excel Data (Beperkt)",
		"advanced": "Geavanceerde opties",
		"ok": "OK",
		"changeEmail": "Wijzigen",
		"showHints": "Hints afbeelden",
		"general": "Algemeen",
		"xlsxData": "Excel-gegevens",
		"newPassword": "Nieuw wachtwoord",
		"hideAll": "Alle verbergen",
		"confirmPassword": "Wachtwoord bevestigen",
		"AILearning_config_description": "De aanbevelingen van het product verbeteren door Cognos Analytics in staat te stellen te leren over uw gebruik.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "De link naar de Support Portal werkt niet.",
		"log_level_Warn": "Waarschuwing",
		"contentSettings": "Inhoudsinstellingen",
		"setHomeButton": "Instellen",
		"myCapabilities": "Mijn mogelijkheden",
		"homePage": "Homepage",
		"helpErrorMessage": "Probeer het opnieuw.  Als het probleem blijft bestaan, waarschuwt u de beheerder.",
		"loadingProfile": "Profiel laden",
		"portal": "Portal",
		"metricsPackage": "Nieuw pakket",
		"myCredentials": "Mijn legitimatiegegevens",
		"myApiKeys": "Mijn API-sleutels",
		"credentialCreate": "Maken",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Wachtwoord kan niet worden gewijzigd\n",
		"showHiddenObjects": "Verborgen items weergeven",
		"csv": "CSV",
		"docsErrorTitle": "De link naar de documentatie werkt niet.",
		"log_level_Error": "Fout",
		"wrongPassword": "Verificatie mislukt",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "Informatie",
		"welcomeBanner": "Welkomstbanner",
		"helpErrorTitle": "De link naar de Help-informatie werkt niet.",
		"contentLocale": "Inhoudstaal",
		"pdf": "PDF",
		"oldPassword": "Oud wachtwoord",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Toegankelijkheidsfuncties",
		"manageLogging": "Logboekregistratie",
		"loggingConfigurationSlideoutA11yLabel": "Configuratie logboekregistratie",
		"communityErrorTitle": "De link naar de Community werkt niet.",
		"companionApps": "Verwante toepassingen",
		"setHomeLabel": "Home instellen als (huidige view)",
		"metricsExportTask": "Nieuwe export",
		"csvRestricted": "CSV (Beperkt)",
		"newFeaturesErrorMessage": "Probeer het opnieuw.  Als het probleem blijft bestaan, waarschuwt u de beheerder.",
		"contributor": "Contributor",
		"showAll": "Alles afbeelden",
		"logging_active": "Logboekregistratie is voor:",
		"html": "HTML",
		"profileAndSettings": "Profiel en instellingen",
		"baseTextDirection": "Basisrichting voor tekst",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Wachtwoord",
		"invalidEmail": "Geef een geldig e-mailadres op",
		"credentialCreateSuccess": "U hebt uw legitimatiegegevens gemaakt",
		"settings": "Instellingen",
		"restrictedFormatSelected": "U hebt geen mogelijkheid om rapporten in deze indeling uit te voeren, maar u kunt rapporten in deze indeling  wel openen.",
		"usageDataDeletionConfirmation": "Door het verwijderen van gebruiksgegevens wordt AI-learning gereset. Weet u zeker dat u gebruiksgegevens wilt wissen?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Details bekijken",
		"deleteUsageData": "Gebruiksgegevens wissen:",
		"showPassword": "Wachtwoord afbeelden",
		"AILearning_config_title": "AI-learning",
		"myPreferencesSlideoutLabel": "Profiel en instellingen",
		"passWordChangeSuccess": "Uw wachtwoord is gewijzigd",
		"logging_level": "Logboekniveau:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Probeer het opnieuw.  Als het probleem blijft bestaan, waarschuwt u de beheerder.",
		"cancel": "Annuleren",
		"shareSetError": "Deze actie kan niet worden uitgevoerd voordat u deze view hebt gesloten en weer geopend.",
		"passwordNotMatch": "Wachtwoord komt niet overeen",
		"xml": "XML",
		"xmlRestricted": "XML (Beperkt)",
		"openMenu": "Menu openen",
		"closeMenu": 'Menu sluiten'
});